module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-01.762ac3c5.png";